import React from 'react'
import AppBlobCache from '../../AppBlobCache'
import GlobalStorage from "../storage/GlobalStorage";
import AdmZip from 'adm-zip';


export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {

    }
  }

  render()
  {
    return (
        <span>
          <input
              id={`wordImport`}
              type={`file`}
              className={`inputfile`}
              onChange={(e) => {
                
                if (e.target.files && e.target.files.length > 0 && e.target.files[0])
                {
                  var reader = new FileReader();
                  var names = {};
                  reader.onload = ((theFile) => {
                    return (e) => {

                      
                      var bytes,buf ;
                      var readLen=e.target.result.byteLength;
                      var arrayBuffer = reader.result
                      bytes = new Uint8Array(arrayBuffer);
                      //console.log('insidebytes is '+bytes);
                      buf = new Buffer(e.target.result.byteLength);
                      for (var i = 0; i < buf.length; ++i) {
                        buf[i] = bytes[i];
                      }
                      //console.log(e.target.result.byteLength+' length is '+bytes.byteLength);
                      var myZip = e.target.result;   
                      //console.log('bytes is '+bytes);
                      //console.log('buf is '+buf);

                      var zip = new AdmZip(buf);                                                                                        
                      var resultList = [];
                      
                      //将document.xml(解压缩后得到的文件)读取为text内容
                      var contentXml = zip.readAsText("word/document.xml");
                      console.log(contentXml);
                      //正则匹配出对应的<w:p>里面的内容,方法是先匹配<w:p>,再匹配里面的<w:t>,将匹配到的加起来即可
                      //注意？表示非贪婪模式(尽可能少匹配字符)，否则只能匹配到一个<w:p></w:p>
                      var matchedWP = contentXml.match(/<w:p.*?>.*?<\/w:p>/gi);
                      //继续匹配每个<w:p></w:p>里面的<w:t>,这里必须判断matchedWP存在否则报错
                      if(matchedWP){
                        matchedWP.forEach(function(wpItem){
                          //detect new line and replace it with \n (\\n for json format)
                          var wpItem_w_break = wpItem.replace(new RegExp(/<w:br\/>/,'g'),"<w:t>\\n</w:t>");
                          console.log(wpItem_w_break);
                          
                          //注意这里<w:t>的匹配，有可能是<w:t xml:space="preserve">这种格式，需要特殊处理
                          var matchedWT = wpItem_w_break.match(/(<w:t>(.|\n)*?<\/w:t>)|(<w:t\s.[^>]*?>(.|\n)*?<\/w:t>)/gi);										
                          
                          
                          if(matchedWT){
                            var textContent = '';
                            matchedWT.forEach(function(wtItem){
                              //如果不是<w:t xml:space="preserve">格式
                              if(wtItem.indexOf('xml:space')===-1){
                                textContent+=wtItem.slice(5,-6);
                              }else{
                                textContent+=wtItem.slice(26,-6);
                              }
                            });

                            textContent = textContent.toString().replace(/"/g, '\\"');
                            textContent = textContent.toString().replace(/&gt;/g, '>');
                            textContent = textContent.toString().replace(/&lt"/g, '<');
                            
                            // var for parsing name                            
                            var name=[''];						
                            

                            
                            //extracing pargraph alignment
                            var align_regex = /(<w:jc w:val="(.+?)")\/>/g;					
                                        
                            if (textContent =="\\n\\n\\n"){
                              resultList.push({
                                text:textContent,
                                align:"scene",
                                name:name[0]
                              });		

                            }else if (wpItem.match(align_regex)){
                              //extract right/ center if alignment tag found
                              wpItem.replace(align_regex, function(match, matchedString, alignment) {
                                if (alignment =='both') alignment = "left";
                                if (alignment == "right" || alignment =="left"){
                                  //only parsing name for right and left
                                  var name_regex = /(.+?)：/g;						
                                  if (textContent.match(name_regex)){
                                    name = textContent.match(name_regex);
                                    var string = name[0];
                                    name[0] = name[0].replace("：","");
                                    textContent=textContent.replace(string,"");
                                    //console.log(string);
                                    //console.log(textContent);
                                    names[ name[0] ] = name[0];
                                  }
                                }

                                resultList.push({
                                  text:textContent,
                                  align:alignment,
                                  name:name[0]
                                });							
                              });
                            }else{
                              //default left

                              //only parsing name for right and left
                              var name_regex = /(.+?)：/g;						
                              if (textContent.match(name_regex)){
                                name = textContent.match(name_regex);
                                var string = name[0];
                                name[0] = name[0].replace("：","");
                                textContent=textContent.replace(string,"");
                                //console.log(string);
                                //console.log(textContent);
                                names[ name[0] ] = name[0];
                              }

                              resultList.push({
                                text:textContent,
                                align:"left",
                                name:name[0]
                              });							
                              
                            }												
                          }
                        });

                        var GS = new GlobalStorage();
                        var unique_names = Object.keys(names);
                        GS  .storyEpisode.characters.pop();
                        for (const key of unique_names){
                          GS.addCharacter(key);
                        }
                                      
                        
                        var json ='{"project_name":"'+GS.getStoryEpisode().project_name+'",';
                        json +='"author":"'+GS.getStoryEpisode().author+'",';
                        json +='"email":"'+GS.getStoryEpisode().email+'",';                      

                        json+='"items":[{"title":"Scene","type":"Scene"},';
                          resultList.forEach(function(row){
                            switch (row.align){
                              case "left":
                                json+='{"title":"Text","type":"Text","_attributes":{"style":"msg","itemColor":"#c1cfff","position":"left"},"text":{"enabled":true,"_text":"'+row.text+'","_attributes":{"color":"#000000","size":"medium","style":"regular","anim":"line"}},"name":{"enabled":true,"_text":"'+row.name+'","_attributes":{"color":"#ffffff","size":"small","style":"regular"}},"bg":{"_attributes":{}},"sound":{"_attributes":{}},"overlay":{"_attributes":{},"media":{"_attributes":{}}},"isSelected":false},';
                              break;
                              case "center":
                                json+='{"title":"Narrative","type":"Narrative","_attributes":{"style":"narrative","itemColor":"","position":"center"},"text":{"enabled":true,"_text":"'+row.text+'","_attributes":{"color":"#ffffff","size":"medium","style":"regular","anim":"line"}},"name":{"enabled":false,"_text":"","_attributes":{"color":"#ffffff","size":"small","style":"regular"}},"bg":{"_attributes":{}},"sound":{"_attributes":{}},"overlay":{"_attributes":{},"media":{"_attributes":{}}},"isSelected":false},';
                              break;
                              case "right":
                                json+='{"title":"Text","type":"Text","_attributes":{"style":"msg","itemColor":"#DDF8C6","position":"right"},"text":{"enabled":true,"_text":"'+row.text+'","_attributes":{"color":"#000000","size":"medium","style":"regular","anim":"line"}},"name":{"enabled":true,"_text":"'+row.name+'","_attributes":{"color":"#ffffff","size":"small","style":"regular"}},"bg":{"_attributes":{}},"sound":{"_attributes":{}},"overlay":{"_attributes":{},"media":{"_attributes":{}}},"isSelected":false},';
                              break;		
                              case "scene":
                                json+='{"title":"Scene","type":"Scene"},';
                                break;
                            }		
                          });
                          json = json.substring(0,json.length-1);
                          json+=']}';
                          
                          var newArr = JSON.parse(json);
                          GS.setStoryEpisode(newArr);
                          console.log('//WordImportInput:GlobalStorage().setStoryEpisode(newArr)');
                          
                      } 
                      //new GlobalStorage().setStoryEpisode(newArr);
                      this.props.onChange && this.props.onChange(e, theFile.name, null);
                    };
                  })(e.target.files[0]);
                  reader.readAsArrayBuffer(e.target.files[0]);  
                  
                  
                  
                }
                else
                {
                  this.props.onChange && this.props.onChange(e, null, null);
                }
              }}
          />
          {/*this.props.value*/}
          <label for="wordImport" class="btn-primary btn mb-0">上載Word檔</label>          
        </span>
    )
  }
}